<template>
  <apexchart ref="chartPorHora" type="area" height="250" :options="chartOptions" :series="seriesLine" />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'LineChart',
  props: ['dataLine', 'optionsLine', 'graphKey'],
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    seriesLine: [
      // {
      //   name:"Atendidas",
      //   data:[],
      // },
      // {
      //   name:"Atendidas",
      //   data:[],
      // },
      // {
      //   name:"Atendidas",
      //   data:[],
      // },
    ],
    chartOptions: {
      colors: ['#66BB6A', '#EF5350', '#FDD835', "#FF5733"],
      chart: {
        type: 'area',
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      xaxis: {
        type: 'category',
        categories: [],
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 90],
        },
      },
    },
  }),
  updated(){
      this.$refs.chartPorHora.chart.dataURI().then(uri => {
        this.$emit('uri',uri);
      });

  },
  

  watch: {
    dataLine: {
      handler() {
        if(this.seriesLine.length){
          this.seriesLine.splice(0, this.seriesLine.length)
        }
        for (const key in this.dataLine) {
          if(key != 'name'){
            this.seriesLine.push(
              {
                name: key,
                data: this.dataLine[key]
              }
            )
          }  
        }

        // this.seriesLine[0].name = this.dataLine.name[0]
        // this.seriesLine[1].name = this.dataLine.name[1]
        // this.seriesLine[2].name = this.dataLine.name[2]

        // this.seriesLine[0].data = []
        // this.seriesLine[1].data = []
        // this.seriesLine[2].data = []

        // let values = Object.keys(this.dataLine)
        // this.seriesLine[0].data = this.dataLine[values[0]]
        // this.seriesLine[1].data = this.dataLine[values[1]]
        // this.seriesLine[2].data = this.dataLine[values[2]]
        // this.seriesLine.splice(0, 1, this.seriesLine[0])

      },
      deep: true,
    },

    optionsLine() {
      setTimeout(() => (this.chartOptions = this.optionsLine), 350)
    },
  },
}
</script>
